import React from 'react';

import Button from '../../../components/ui/Button';

const TeamFilter = ({ 
  activeFilter, 
  onFilterChange, 
  activeExpertise, 
  onExpertiseChange,
  activeExperience,
  onExperienceChange,
  isMobile = false 
}) => {
  const filterOptions = [
    { id: 'all', label: 'All Team', icon: 'Users' },
    { id: 'leadership', label: 'Leadership', icon: 'Crown' },
    { id: 'ai-engineering', label: 'AI Engineering', icon: 'Brain' },
    { id: 'software-development', label: 'Software Dev', icon: 'Code' },
    { id: 'analytics', label: 'Analytics', icon: 'BarChart3' },
    { id: 'cybersecurity', label: 'Cybersecurity', icon: 'Shield' }
  ];

  const expertiseOptions = [
    'Machine Learning',
    'Deep Learning',
    'Natural Language Processing',
    'Computer Vision',
    'Data Science',
    'Cloud Architecture',
    'DevOps',
    'Frontend Development',
    'Backend Development',
    'Mobile Development',
    'Blockchain',
    'Cybersecurity',
    'Network Security',
    'Penetration Testing'
  ];

  const experienceOptions = [
    { id: 'all', label: 'All Experience' },
    { id: 'junior', label: '2-5 years' },
    { id: 'mid', label: '5-10 years' },
    { id: 'senior', label: '10+ years' }
  ];

  if (isMobile) {
    return (
      <div className="bg-white rounded-xl shadow-soft border border-border p-4 mb-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Team Category
            </label>
            <select
              value={activeFilter}
              onChange={(e) => onFilterChange(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              {filterOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Experience Level
            </label>
            <select
              value={activeExperience}
              onChange={(e) => onExperienceChange(e.target.value)}
              className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20"
            >
              {experienceOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          
          {activeExpertise && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">
                Filtered by: {activeExpertise}
              </span>
              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                onClick={() => onExpertiseChange('')}
              >
                Clear
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-soft border border-border p-6 mb-8">
      <div className="space-y-6">
        {/* Category Filter */}
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4">Filter by Category</h3>
          <div className="flex flex-wrap gap-2">
            {filterOptions.map((option) => (
              <Button
                key={option.id}
                variant={activeFilter === option.id ? 'default' : 'outline'}
                size="sm"
                iconName={option.icon}
                iconPosition="left"
                onClick={() => onFilterChange(option.id)}
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>
        
        {/* Experience Filter */}
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4">Experience Level</h3>
          <div className="flex flex-wrap gap-2">
            {experienceOptions.map((option) => (
              <Button
                key={option.id}
                variant={activeExperience === option.id ? 'default' : 'outline'}
                size="sm"
                onClick={() => onExperienceChange(option.id)}
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>
        
        {/* Expertise Tags */}
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4">Filter by Expertise</h3>
          <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto">
            {expertiseOptions.map((expertise) => (
              <button
                key={expertise}
                onClick={() => onExpertiseChange(activeExpertise === expertise ? '' : expertise)}
                className={`px-3 py-1 text-sm rounded-full transition-smooth ${
                  activeExpertise === expertise
                    ? 'bg-primary text-white' :'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
                }`}
              >
                {expertise}
              </button>
            ))}
          </div>
        </div>
        
        {/* Active Filters */}
        {(activeFilter !== 'all' || activeExperience !== 'all' || activeExpertise) && (
          <div className="pt-4 border-t border-border">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">
                Active filters applied
              </span>
              <Button
                variant="ghost"
                size="sm"
                iconName="RotateCcw"
                iconPosition="left"
                onClick={() => {
                  onFilterChange('all');
                  onExperienceChange('all');
                  onExpertiseChange('');
                }}
              >
                Reset All
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamFilter;